import { CompanyFeatureFlag, CompanyType, UserFeatureFlag, UserProfileRole } from '@@types/api.types';
import { hasMeiaStudioCampaignAccess } from '@azymmetric/shared/access/meia-studio-access.util';

type MeiaStudioAccessCompany = {
  featureFlags?: readonly CompanyFeatureFlag[] | null;
  id: string;
  type?: CompanyType | null;
};

type MeiaStudioAccessUser = {
  companies?: readonly MeiaStudioAccessCompany[] | null;
  featureFlags?: readonly UserFeatureFlag[] | null;
  profile?: {
    role?: UserProfileRole | null;
  } | null;
  selectedCompanyId?: string | null;
};

export function canAccessMeiaStudioV1(user?: MeiaStudioAccessUser | null): boolean {
  return canAccessMeia(user);
}

export function canAccessMeiaCampaigns(user?: MeiaStudioAccessUser | null): boolean {
  return canAccessMeia(user);
}

function canAccessMeia(user?: MeiaStudioAccessUser | null): boolean {
  const selectedCompany = user?.companies?.find((company) => company.id === user.selectedCompanyId);

  return hasMeiaStudioCampaignAccess({
    featureFlags: user?.featureFlags,
    organization: selectedCompany
      ? {
          featureFlags: toUserAccessFeatureFlags(selectedCompany.featureFlags),
          isIntelligenceOrganization: selectedCompany.type === CompanyType.INTELLIGENCE,
        }
      : null,
    role: user?.profile?.role,
  });
}

function toUserAccessFeatureFlags(featureFlags?: readonly string[] | null): UserFeatureFlag[] {
  return (featureFlags ?? []).filter((flag): flag is UserFeatureFlag =>
    Object.values(UserFeatureFlag).includes(flag as UserFeatureFlag),
  );
}
